module.exports = __webpack_public_path__ + "media/images/background_graphics/trust_and_safety_background_vector_mobile-094051c86d164ba7139f022ec3cc4e9d.svg";